// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';

// Components
import Checkbox from '../core/checkbox';
import FormButtons from '../core/form-buttons';
import Input from '../core/input';
import LanguageSelect from '../app/language-select';
import Loading from '../core/loading';
import rsqlConfig from '../../../config/rsql-config';
import SearchPagination from '../app/search-pagination';
import SearchTableWithSort from '../app/search-tablewithsort';
import Select from '../core/select';
import ServicesExportPanelAction from '../app/services-export-panel-action';
import ServicesSearchForm from '../app/services-search-form';
import ServicesSearchPanelAction from '../app/services-search-panel-action';

// Containers
import withSearch from '../../containers/with-search';

const servicesDataKey = 'moviesAndProgramsEpisodes';

class MoviesAndProgramsEpisodes extends Component {
    getColumnConfig() {
        const detailLink = '/movies-and-programs';

        return [
            {
                dataKey: 'title',
                formatter: 'moviesAndProgramsTitle',
                link: detailLink,
                linkKey: ['echostarId', 'roviProgramId'],
                sortKey: 'title.sortable',
                title: 'Title',
                type: 'link',
                width: '17%',
            },
            {
                dataKey: 'episodeSeason',
                title: 'S',
                tooltip: 'Season Number',
                width: '5%',
            },
            {
                dataKey: 'episodeNumber',
                title: 'E',
                tooltip: 'Episode Number',
                width: '5%',
            },
            {
                dataKey: 'echostarContentType',
                title: 'Type',
                tooltip: 'Echostar Content Type',
                width: '6%',
            },
            {
                dataKey: 'echostarId',
                link: detailLink,
                linkKey: ['echostarId', 'roviProgramId'],
                title: 'E* ID',
                tooltip: 'Echostar ID',
                type: 'link',
                width: '14%',
            },
            {
                dataKey: 'description',
                title: 'Description',
                width: '34%',
            },
            {
                dataKey: 'releaseYear',
                title: 'Released',
                tooltip: 'Release Year',
                type: 'string',
                width: '7%',
            },
            {
                dataKey: 'originalAirDate',
                title: 'Original Air',
                tooltip: 'Original Air Date',
                type: 'date',
                width: '12%',
            },
        ];
    }

    getPaginationProps() {
        const {query, totalPages} = this.props;

        return {
            maxResults: 50000,
            maxPages: 9,
            query,
            totalPages,
        };
    }

    getRowDetails() {
        return {
            whitelistKeys: [
                'description',
                'shortDescription',
                'sportDatetime',
                'sportSeasonType',
                'episodeSeason',
                'programType',
                'genres',
                'runtime',
                'rating',
                'titleLanguages',
                'descriptionLanguage',
            ],
        };
    }

    getTablewithsortProps() {
        return {
            columnConfig: this.getColumnConfig(),
            formName: servicesDataKey,
            noRecordsError: 'No available episodes.',
            noReset: true,
            rowDetails: this.getRowDetails(),
            servicesDataKey,
            ...this.props,
        };
    }

    renderContent() {
        const {fetching, searchData} = this.props;

        return (
            <span>
                <Loading loading={fetching} />
                <ServicesExportPanelAction exportConfig="moviesAndPrograms" searchData={searchData} />
                <ServicesSearchPanelAction contentRenderer={this.renderForm} />
                <SearchPagination {...this.getPaginationProps()} />
                <SearchTableWithSort {...this.getTablewithsortProps()} />
            </span>
        );
    }

    renderForm = () => (
        <ServicesSearchForm formName={servicesDataKey} servicesDataKey={servicesDataKey}>
            <Input label="Title/Series Title" name="title||seriesTitle" />
            <Input label="Echostar ID" name="echostarId" validate={['number']} />
            <Input label="Echostar3 ID" name="echostarEventString" />
            <Input label="AMS ID" name="roviProgramId" />
            <LanguageSelect defaultOption="Filter by Title Language" label="Title Language" name="titleLanguages" />
            <LanguageSelect
                defaultOption="Filter by Description Language"
                label="Description Language"
                name="descriptionLanguage"
            />
            <Select label="Adult Content" name="genres">
                <option value="">Show all content</option>
                <option value="!Adult">No adult content</option>
                <option value="Adult">Only adult content</option>
            </Select>
            <Checkbox
                label="Shells Only"
                name="roviProgramId#tmsId#sourceId#shellsOnly"
                value={`=rsql=${rsqlConfig.isShell}`}
            />
            <FormButtons />
        </ServicesSearchForm>
    );

    render() {
        return <div className="movies-and-programs-episodes">{this.renderContent()}</div>;
    }
}

MoviesAndProgramsEpisodes.propTypes = {
    fetching: PropTypes.bool,
    query: PropTypes.object,
    searchData: PropTypes.array,
    totalPages: PropTypes.number,
};

export default withSearch(MoviesAndProgramsEpisodes, servicesDataKey);
